//CRN_20251218 - ⚠️ ngOnInit() called for components/directives & not services ⚠️

import CustomStore from 'devextreme/data/custom_store';
import { EncryptionService } from '../../general/encryption-service';
import { environment } from 'src/environments/environment';
import { eSimApiPaths } from 'src/app/core/consts';
import { ExceptionsService } from '../../general/exceptions-service';
import { HttpClientService } from '../../general/http-client-service';
import { IdAndDescriptionDTO } from 'src/app/core/interfaces/general/id-description';
import { Injectable } from '@angular/core';
import { Observable, lastValueFrom, map, of, switchMap } from 'rxjs';
import { TariffUsageDTO } from 'src/app/core/models/system/tariff/tariff-usage.dto';
import { StringResultDTO } from 'src/app/core/interfaces/general/string-result';

@Injectable({ providedIn: 'root' })

export class TariffsUsageService {
  
  constructor(
    private encryptionService: EncryptionService,
    private exceptionsService: ExceptionsService,
    private httpClientService: HttpClientService
  ) { }
    
  public getById(id: number): Observable<TariffUsageDTO> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>id, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const idEncSS=encResult.result;
                            
                            return this.httpClientService.getById(environment.eSimApi +
                                                                  eSimApiPaths.TariffsUsage +
                                                                  "?idEncSS=" + idEncSS, undefined); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public getIdAndDescription(): Observable<IdAndDescriptionDTO[]> {
    try {
      return this.httpClientService.get<TariffUsageDTO[]>(environment.eSimApi +
                                                          eSimApiPaths.TariffsUsage + "/" +
                                                          eSimApiPaths.TariffsUsageGetTariffsUsage)
      .pipe(
        map(x => x.map(this.idAndDescriptionConverter))
      );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  private idAndDescriptionConverter(tariffUsage: TariffUsageDTO) {
    return {id: tariffUsage.id, description: tariffUsage.tariffName};
  }

  public idAndDescriptionLookupDataSource(): {} {
    try {
      return {
        store: new CustomStore({
          key: "id",
          loadMode: "raw",
          load: () => {
            return lastValueFrom(this.getIdAndDescription());
          }
        }),
        sort: "description"
      };
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return {};
    }
  }
  
  public post(usageTariff: TariffUsageDTO): Observable<TariffUsageDTO> {
    try {
      //JSON.stringify(usageTariff)
      
      return this.encryptionService.encrypt_AesServerSideForWeb(JSON.stringify(usageTariff))
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const objectEnc=encResult.result;
                            
                            return this.httpClientService.post(environment.eSimApi +
                                                               eSimApiPaths.TariffsUsage +
                                                               "?objectEnc=" + objectEnc, {}); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
      
  public put(usageTariff: TariffUsageDTO): Observable<TariffUsageDTO> {
    try {
      //JSON.stringify(usageTariff)
      
      return this.encryptionService.encrypt_AesServerSideForWeb(JSON.stringify(usageTariff))
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const objectEnc=encResult.result;
                            
                            return this.httpClientService.put(environment.eSimApi +
                                                              eSimApiPaths.TariffsUsage +
                                                              "?id=" + usageTariff.id +
                                                              "&objectEnc=" + objectEnc, undefined, {}); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
        
  public save(usageTariff: TariffUsageDTO): Observable<any> {
    try {
      //JSON.stringify(usageTariff);

      if (usageTariff.id && <number>usageTariff.id>0)
        return this.put(usageTariff);
      
      return this.post(usageTariff);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
}
